/**
 * Admin-only banner: a visibility-tagged banner shown to admins, nothing to
 * everyone else.
 *
 * A presentation component — the caller owns translation and any interpolation
 * (like Editorial Dashboard links). Self-gates on `useIsAdmin()`.
 */

import { Banner } from 'component/banner';
import { spacings } from 'component/constants';
import { RichText } from 'component/richtext';
import { VisibilityTag } from 'component/tag/visibility-tag';
import { StyleSheet, View } from 'react-native';
import { useIsAdmin } from 'util/admin';

export type AdminBannerProps = {
    text: string;
};

export function AdminBanner({ text }: AdminBannerProps) {
    const isAdmin = useIsAdmin();
    if (!isAdmin) return null;

    return (
        <Banner>
            <View style={s.content}>
                <View style={{ marginLeft: -spacings.xxs }}>
                    <VisibilityTag type='admin' />
                </View>
                <RichText text={text} type='small' />
            </View>
        </Banner>
    );
}

const s = StyleSheet.create({
    content: {
        gap: spacings.md,
    },
});
